import { Game } from './Game';

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js')
    .then(() => console.log('Service worker registered'))
    .catch((err) => console.log('Service worker registration failed:', err));
}

const game = new Game();

game.init().then(() => {
  // Hide loading, show instructions
  const loading = document.getElementById('loading');
  const instructions = document.getElementById('instructions');

  if (loading) loading.style.display = 'none';
  if (instructions) instructions.style.display = 'block';

  // Start the game loop
  game.start();
}).catch((error) => {
  console.error('Failed to initialize game:', error);
  const loading = document.getElementById('loading');
  if (loading) {
    loading.textContent = 'INITIALIZATION FAILED';
    loading.style.color = '#ff0000';
  }
});
